module.exports = __webpack_public_path__ + "static/media/background-blue.9e855cb5.svg";